import Logger from "./Logger";
import { injectScript } from "./Utils";

window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];

// disable initial load so we can control ad requests
window.googletag.cmd.push(function () {
  window.googletag.pubads().disableInitialLoad();
  Logger.log("Disabled googletag auto loading");
});
injectScript("//www.googletagservices.com/tag/js/gpt.js");

export default () => window.googletag;
